import {ProjectType} from "../project-type.entity";

export class DummyProjectType extends ProjectType {

    protected _uid = `dummy-project-type`;

}